import React, { useState } from 'react';
import theme from '../../theme/globalTheme';
import {
  Card,
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  message,
  Divider
} from 'antd';
import { FileAddOutlined } from '@ant-design/icons';
import { generateDocument } from '../../utils/documentGenerator';

const { Option } = Select;
const { TextArea } = Input;

function DocumentGenerator() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleGenerate = async (values) => {
    setLoading(true);
    try {
      const documentData = {
        client_name: values.client_name,
        date: values.date ? values.date.format('DD/MM/YYYY') : '',
        montant: values.montant || '',
        description: values.description || '',
      };

      await generateDocument(values.type, documentData);

      message.success('Document généré et téléchargé avec succès!');
      form.resetFields();

    } catch (error) {
      message.error('Erreur lors de la génération: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: theme.colors.bgDark, padding: '20px' }} className="p-6">
      <Card>
        <h1 className="text-2xl font-bold mb-4">Génération de documents</h1>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleGenerate}
        >
          <Form.Item
            name="type"
            label="Type de document"
            rules={[{ required: true, message: 'Sélectionnez le type de document' }]}
          >
            <Select placeholder="Choisir un type">
              <Option value="Contrat">Contrat</Option>
              <Option value="Confirmation">Confirmation</Option>
              <Option value="Facturation">Facturation</Option>
            </Select>
          </Form.Item>

          <Divider />

          <Form.Item
            name="client_name"
            label="Nom du client"
            rules={[{ required: true, message: 'Le nom du client est requis' }]}
          >
            <Input placeholder="Nom complet du client" />
          </Form.Item>

          <Form.Item
            name="date"
            label="Date"
          >
            <DatePicker className="w-full" format="DD/MM/YYYY" />
          </Form.Item>

          <Form.Item
            name="montant"
            label="Montant"
          >
            <Input prefix="€" placeholder="0.00" />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
          >
            <TextArea rows={4} placeholder="Description du service..." />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              icon={<FileAddOutlined />}
              size="large"
            >
              Générer le document
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}

export default DocumentGenerator;
